<div class="grid-gap-x6">
  <h1>{{ 'SIGN_IN' | translate }}</h1>

  <form class="form" [formGroup]="formGroup">
    <label class="label">
      {{ "EMAIL" | translate }} :
      <input class="input" nz-input formControlName="login">
    </label>
    <label class="label">
      {{ "PASSWORD" | translate }} :
      <input class="input" nz-input type="password" formControlName="password">
    </label>
  </form>

  <div class="grid-columns-one-to-four-gap-x2">
    <button
      class="grid-columns-start-tow flex-align-items-center"
      nz-button
      nzType="link"
      routerLink="/auth/forgot-password"
    >{{'FORGOT_PASSWORD' | translate}}</button>
  </div>

  <div class="grid-columns-one-to-four-gap-x2">
    <button
      [nzLoading]="loadingFormState"
      [disabled]="loadingFormState"
      (click)="onSubmit()"
      class="grid-columns-start-tow"
      nz-button
      nzType="primary"
    >{{ 'SIGN_IN' | translate }}</button>
  </div>

  <ng-container *ngIf="googleUrlResponse$ | async as googleUrlResponse">
    <div class="grid-columns-one-to-four-gap-x2">
      <nz-divider nzText="or" class="grid-columns-start-tow"></nz-divider>
    </div>

    <div class="grid-columns-one-to-four-gap-x2">
      <button
          nz-button
          nzType="default"
          class="grid-columns-start-tow"
          (click)="onGoogleClick(googleUrlResponse)"
      >
        <span nz-icon nzType="google" nzTheme="outline"></span>
        Google
      </button>
    </div>
  </ng-container>

  <div class="grid-columns-one-to-four-gap-x2">
    <div class="text-container grid-columns-start-tow">
      <span>{{ 'DONT_HAVE_ACCOUNT' | translate }}?&nbsp;</span>
      <a nz-button nzType="link" routerLink="/auth/register">{{'SIGN_UP' | translate}}</a>
    </div>
  </div>

</div>
